export const INVOICE_GENERATION_DELAY = 1000; // 1 second delay before creating invoice
export const INVOICE_GENERATION_STATUS = {
    PENDING: "pending",
    SUCCESS: "success",
    FAILED: "failed",
};
export const INVOICE_STATUS = {
    DRAFT: {
        id: "DRAFT",
        label: "Draft",
        color: "inherit",
    },
    AWAITING_PAYMENT: {
        id: "AWAITING_PAYMENT",
        label: "Awaiting payment",
        color: "primary",
    },
    PAID: {
        id: "PAID",
        label: "Paid",
        color: "secondary",
    },
    VOID: {
        id: "VOID",
        label: "Void",
        color: "error",
    },
    REFUNDED: {
        // deprecated, refunded invoices should retain their current status
        id: "REFUNDED",
        label: "Refunded",
        color: "inherit",
    },
    PENDING: {
        id: "PENDING",
        label: "Pending",
        color: "error",
    },
};
export const INVOICE_CREATION_SOURCE = {
    BOOKING_PAGE: "BOOKING_PAGE",
    ADD_ON_CHARGE: "ADD_ON_CHARGE",
    INVOICE_PORTAL: "INVOICE_PORTAL",
    RESPONDENT_CHARGE: "RESPONDENT_CHARGE",
    WORKFLOW: "WORKFLOW",
    XERO: "XERO",
};
export const INVOICE_STATUS_ACTION = {
    MARK_AS_PAID: "MARK_AS_PAID",
    MARK_AS_AWAITING_PAYMENT: "MARK_AS_AWAITING_PAYMENT",
    REFUNDED: "REFUNDED",
    VOID: "VOID",
};
export const paymentSources = {
    STRIPE: "stripe",
};
export const paymentMethods = {
    ONLINE: {
        id: "ONLINE",
        label: "Online",
    },
};
export const bookingPaymentStatuses = {
    SUCCESS: "SUCCESS",
    PENDING: "PENDING",
    FAILED: "FAILED",
};
export const paymentStatuses = {
    PAID: {
        id: "PAID",
        label: "Paid",
    },
    REFUNDED: {
        id: "REFUNDED",
        label: "Refunded",
    },
    PENDING: {
        id: "PENDING",
        label: "Pending",
    },
};
export const PAYMENT_STATUSES = Object.freeze({
    AWAITING_PAYMENT: {
        id: "AWAITING_PAYMENT",
        label: "Awaiting payment",
    },
    PAID: {
        id: "PAID",
        label: "Paid",
    },
    REFUNDED: {
        id: "REFUNDED",
        label: "Refunded",
    },
    VOID: {
        id: "VOID",
        label: "Void",
    },
});
export const BILLING_SCOPES = {
    WHOLE_SURVEY: {
        id: "wholeSurvey",
        getLabel: (entityName) => `Bill a fixed amount for the entire ${entityName.toLowerCase()}`,
    },
    PER_QUESTION: {
        id: "perQuestion",
        getLabel: () => "Bill based on specific questions and response options",
    },
};
export const BILLABLE_TYPES = {
    SERVICE: "service",
    SURVEY_TYPE: "surveyType",
    UPLOAD: "upload",
    RESPONDENT_NOTE: "respondentNote",
    TEMPLATE: "template",
};
export const TEMPLATE_TYPE = {
    NOTE: "Note",
    MAIL: "Mail",
    SMS: "Sms",
};
export var ITEM_BILLABLE_TYPE;
(function (ITEM_BILLABLE_TYPE) {
    ITEM_BILLABLE_TYPE["ITEM_CHARGE"] = "ITEM_CHARGE";
    ITEM_BILLABLE_TYPE["METERED_CHARGE"] = "METERED_CHARGE";
})(ITEM_BILLABLE_TYPE || (ITEM_BILLABLE_TYPE = {}));
export const bookingPaymentFetchType = {
    GET_STRIPE_PAYMENT: "getStripePayment",
};
export var STRIPE_REPORT_REQUEST_STATUS;
(function (STRIPE_REPORT_REQUEST_STATUS) {
    STRIPE_REPORT_REQUEST_STATUS["NOT_REQUESTED"] = "not_requested";
    STRIPE_REPORT_REQUEST_STATUS["PENDING"] = "pending";
    STRIPE_REPORT_REQUEST_STATUS["COMPLETE"] = "complete";
})(STRIPE_REPORT_REQUEST_STATUS || (STRIPE_REPORT_REQUEST_STATUS = {}));
//# sourceMappingURL=payment.js.map